<template>
  <div class="modal-overlay" v-if="visible" @click.self="$emit('cancel')">
    <div class="modal-card form-modal">
      <h2 class="modal-title">{{ isEditing ? 'Editar Participante' : 'Novo Participante' }}</h2>

      <form @submit.prevent="handleSubmit" class="participant-form">
        <div class="form-row">
          <div class="form-group">
            <label class="label">Nome *</label>
            <input class="input" type="text" v-model="form.name" placeholder="Nome completo" />
            <span class="error-msg" v-if="errors.name">{{ errors.name }}</span>
          </div>
          <div class="form-group form-sm">
            <label class="label">Idade *</label>
            <input class="input" type="number" v-model="form.age" min="0" max="150" />
            <span class="error-msg" v-if="errors.age">{{ errors.age }}</span>
          </div>
        </div>

        <div class="form-group">
          <label class="label">Lider / Responsavel *</label>
          <input class="input" type="text" v-model="form.leader" placeholder="Nome do lider" />
          <span class="error-msg" v-if="errors.leader">{{ errors.leader }}</span>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="label">Celular</label>
            <input class="input" type="tel" v-model="form.number" placeholder="(XX) XXXXX-XXXX" />
          </div>
          <div class="form-group">
            <label class="label">Celular Responsavel *</label>
            <input class="input" type="tel" v-model="form.numberFamily" placeholder="(XX) XXXXX-XXXX" />
            <span class="error-msg" v-if="errors.numberFamily">{{ errors.numberFamily }}</span>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="label">Cidade</label>
            <input class="input" type="text" v-model="form.city" placeholder="Cidade" />
          </div>
          <div class="form-group">
            <label class="label">Igreja</label>
            <input class="input" type="text" v-model="form.church" placeholder="Igreja" />
          </div>
        </div>

        <div class="form-group">
          <label class="label">Possui alergia ou usa medicacao?</label>
          <div class="radio-group">
            <label class="radio-label"><input type="radio" value="false" v-model="hasAllergy" /> Nao</label>
            <label class="radio-label"><input type="radio" value="true" v-model="hasAllergy" /> Sim</label>
          </div>
        </div>
        <div class="form-group" v-if="hasAllergy === 'true'">
          <label class="label">Descreva</label>
          <textarea class="input textarea" v-model="form.allergy" placeholder="Detalhes da alergia/medicacao"></textarea>
        </div>

        <div class="form-group form-sm">
          <label class="label">Volumes (bagagem)</label>
          <input class="input" type="number" v-model="form.baggage" min="0" />
        </div>

        <div class="modal-actions">
          <button type="button" class="btn-secondary" @click="$emit('cancel')">Cancelar</button>
          <button type="submit" class="btn-primary">{{ isEditing ? 'Salvar' : 'Cadastrar' }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParticipantForm',
  props: {
    visible: { type: Boolean, default: false },
    participant: { type: Object, default: null }
  },
  emits: ['save', 'cancel'],
  data() {
    return {
      form: this.getEmptyForm(),
      hasAllergy: 'false',
      errors: {}
    }
  },
  computed: {
    isEditing() { return !!this.participant }
  },
  watch: {
    visible(val) {
      if (val) {
        if (this.participant) {
          this.form = { ...this.participant }
          this.hasAllergy = this.participant.allergy ? 'true' : 'false'
        } else {
          this.form = this.getEmptyForm()
          this.hasAllergy = 'false'
        }
        this.errors = {}
      }
    }
  },
  methods: {
    getEmptyForm() {
      return { name: '', age: '', leader: '', number: '', numberFamily: '', city: '', church: '', allergy: '', baggage: '' }
    },
    validate() {
      this.errors = {}
      if (!this.form.name || this.form.name.trim().length < 2) this.errors.name = 'Nome e obrigatorio (min 2 caracteres)'
      const age = Number(this.form.age)
      if (!this.form.age || isNaN(age) || age < 0 || age > 150) this.errors.age = 'Idade invalida'
      if (!this.form.leader || this.form.leader.trim().length < 2) this.errors.leader = 'Lider e obrigatorio'
      if (!this.form.numberFamily) this.errors.numberFamily = 'Celular do responsavel e obrigatorio'
      return Object.keys(this.errors).length === 0
    },
    handleSubmit() {
      if (!this.validate()) return
      const data = { ...this.form }
      if (this.hasAllergy === 'false') data.allergy = ''
      this.$emit('save', data)
    }
  }
}
</script>

<style scoped>
.form-modal { max-width: 600px; }
.participant-form {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-base);
}
.form-group { display: flex; flex-direction: column; }
.form-sm { max-width: 120px; }
.form-row { display: flex; gap: var(--spacing-base); }
.form-row .form-group { flex: 1; }
.textarea { min-height: 70px; resize: vertical; }
.radio-group { display: flex; gap: var(--spacing-base); margin-top: var(--spacing-sm); }
.radio-label {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
  cursor: pointer;
}
@media (max-width: 496px) {
  .form-row { flex-direction: column; }
  .form-sm { max-width: 100%; }
}
</style>
